const pluralOverrides: { [key: string]: string } = {
  person: 'people',
};

export default function pluralize(word: string, count?: number) {
  if (word.endsWith('s')) {
    return word;
  }

  return count === 1 ? word : pluralOverrides[word] || `${word}s`;
}
